<div class="cfg-page">

  <div class="page-header">
    <div class="page-header__info">
      <h1 class="page-header__title"><i class="fal fa-box-open"></i> Types de Conditionnement</h1>
      <p class="page-header__sub">Configuration des types d'emballage disponibles — {{ types.length }} type(s)</p>
    </div>
    <div class="header-actions">
      <button class="btn-create" (click)="ouvrirCreation()"><i class="fal fa-plus"></i> Nouveau type</button>
      <button class="btn-refresh" (click)="charger()" [disabled]="chargement">
        <i class="fal fa-sync" [class.fa-spin]="chargement"></i> Actualiser
      </button>
    </div>
  </div>

  <!-- KPI -->
  <div class="kpi-row">
    <div class="kpi-card"><span class="kpi-val">{{ types.length }}</span><span class="kpi-label">Types</span></div>
  </div>

  <!-- Filtre -->
  <div class="filtres-bar">
    <div class="filtre-search">
      <i class="fal fa-search"></i>
      <input type="text" [(ngModel)]="recherche" (ngModelChange)="appliquerFiltre()" placeholder="Rechercher un type…" />
    </div>
  </div>

  <!-- Chargement -->
  <div class="etat-centre" *ngIf="chargement"><div class="spinner"></div><span>Chargement…</span></div>

  <!-- Vide -->
  <div class="etat-centre" *ngIf="!chargement && typesFiltres.length === 0">
    <i class="fal fa-box-open" style="font-size:36px;color:#cbd5e0"></i>
    <p>Aucun type de conditionnement trouvé.</p>
  </div>

  <!-- Grille -->
  <div class="types-grid" *ngIf="!chargement && typesFiltres.length > 0">
    <div class="type-card" *ngFor="let t of typesFiltres">
      <div class="type-card__icon"><i class="fal fa-box-open"></i></div>
      <div class="type-card__body">
        <strong class="type-card__libelle">{{ t.libelle }}</strong>
        <span class="type-card__articles" *ngIf="nbArticles(t) > 0">
          <i class="fal fa-tag"></i> {{ nbArticles(t) }} article(s)
        </span>
      </div>
      <div class="type-card__actions">
        <button class="btn-action btn-action--teal" (click)="ouvrirEdition(t)" title="Modifier">
          <i class="fal fa-pencil"></i>
        </button>
        <button class="btn-action btn-action--danger" (click)="supprimer(t)" title="Supprimer">
          <i class="fal fa-trash"></i>
        </button>
      </div>
    </div>
  </div>
</div>

<!-- MODAL -->
<div class="modal-backdrop" *ngIf="afficherModal" (click)="fermerModal()">
  <div class="modal-card" (click)="$event.stopPropagation()" style="width: min(480px, 100%)">
    <div class="modal-header">
      <div class="modal-header__left">
        <div class="modal-header__icon"><i class="fal fa-box-open"></i></div>
        <div>
          <h3>{{ modeEdition ? 'Modifier le type' : 'Nouveau type de conditionnement' }}</h3>
          <p class="modal-header__sub">Définissez le libellé du type d'emballage</p>
        </div>
      </div>
      <button class="modal-close" (click)="fermerModal()"><i class="fal fa-times"></i></button>
    </div>
    <div class="modal-body">
      <div class="modal-grid">
        <div class="modal-field modal-field--full">
          <label>Libellé <span class="required">*</span></label>
          <input type="text" [(ngModel)]="formulaire.libelle" placeholder="Ex: Colis, Enveloppe, Palette…" />
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button class="btn-modal-cancel" (click)="fermerModal()"><i class="fal fa-times"></i> Annuler</button>
      <button class="btn-modal-primary" (click)="sauvegarder()" [disabled]="sauvegardeEnCours">
        <ng-container *ngIf="!sauvegardeEnCours"><i class="fal fa-check"></i> {{ modeEdition ? 'Mettre à jour' : 'Créer' }}</ng-container>
        <ng-container *ngIf="sauvegardeEnCours"><div class="spinner spinner--xs spinner--white"></div> Enregistrement…</ng-container>
      </button>
    </div>
  </div>
</div>
